import { render, staticRenderFns } from "./BulkDeletePicklPopup.vue?vue&type=template&id=1cceab71&scoped=true&"
import script from "./BulkDeletePicklPopup.vue?vue&type=script&lang=ts&"
export * from "./BulkDeletePicklPopup.vue?vue&type=script&lang=ts&"
import style0 from "./BulkDeletePicklPopup.vue?vue&type=style&index=0&id=1cceab71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cceab71",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cceab71')) {
      api.createRecord('1cceab71', component.options)
    } else {
      api.reload('1cceab71', component.options)
    }
    module.hot.accept("./BulkDeletePicklPopup.vue?vue&type=template&id=1cceab71&scoped=true&", function () {
      api.rerender('1cceab71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/BulkDeletePicklPopup.vue"
export default component.exports